import { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import { useParams } from "react-router-dom";
import apiCall from "../../api/api-call";
import JobListItem from "./JobListItem";

function JobListSection() {
  const [jobPostFullTime, setJobPostFullTime] = useState([]);
  const [jobPostPartTime, setJobPostPartTime] = useState([]);
  const [jobNature, setJobNature] = useState("Full Time");
  let { category, location, keyword } = useParams();

  const handleTab = (value) => {
    setJobNature(value);
  };

  useEffect(() => {
    let queryParam = new URLSearchParams();

    queryParam.append("jobNature", jobNature);

    if (category) {
      queryParam.append("category", category);
    }
    if (location) {
      queryParam.append("location", location);
    }
    if (keyword) {
      queryParam.append("keyword", keyword);
    }

    //console.log("query string: ", queryParam.toString());

    apiCall
      .getJobListBy(queryParam.toString())
      .then((response) => {
        //console.log("response: ", response);
        if (jobNature === "Full Time") {
          setJobPostFullTime(response.data.response.Items);
        } else {
          setJobPostPartTime(response.data.response.Items);
        }
      })
      .catch((error) => console.log("error: ", error));
  }, [jobNature, category, location, keyword]);

  return (
    <div className="container-xxl py-5">
      <div className="container">
        <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
          Job Listing
        </h1>
        <div
          className="tab-class text-center wow fadeInUp"
          data-wow-delay="0.3s"
        >
          <Nav
            variant="pills"
            as="ul"
            activeKey="link-1"
            bsPrefix="nav nav-pills d-inline-flex justify-content-center border-bottom mb-5"
          >
            <Nav.Item as="li">
              <Nav.Link
                eventKey="link-1"
                bsPrefix="d-flex align-items-center text-start mx-3 ms-0 pb-3"
                onClick={() => handleTab("Full Time")}
                active={jobNature === "Full Time"}
              >
                <h6 className="mt-n1 mb-0">Full Time</h6>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li">
              <Nav.Link
                eventKey="link-2"
                bsPrefix="d-flex align-items-center text-start mx-3 me-0 pb-3"
                onClick={() => handleTab("Part Time")}
                active={jobNature === "Part Time"}
              >
                <h6 className="mt-n1 mb-0">Part Time</h6>
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <div className="tab-content">
            <div
              id="tab-1"
              className={`tab-pane fade show p-0 ${
                jobNature === "Full Time" ? "active" : ""
              }`}
            >
              <JobListItem jobs={jobPostFullTime} />
            </div>
            <div
              id="tab-2"
              className={`tab-pane fade show p-0 ${
                jobNature === "Part Time" ? "active" : ""
              }`}
            >
              <JobListItem jobs={jobPostPartTime} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JobListSection;
